(function () {
  'use strict';

  /*
    The cart count is hidden while the cart is empty.

    The state is set in Liquid from cart.item_count, so the first paint is
    already right and a "0" never flashes. This file exists for what happens
    after that: the count is written by FOUR different scripts, and none of
    them knows the badge can be hidden -

      assets/theme.js.liquid (jQuery, two sites)
      assets/product-card-atc.js (fetch)
      assets/predictive-search.js (fetch)

    Rather than teach each of them - and rather than hope a fifth is never
    added - this watches the count elements themselves. Whoever writes the
    number, the badge follows one tick later, and a path that is added
    later is covered for free.

    A MutationObserver, not a poll and not a cart event: there is no single
    cart event the three add paths agree on (that is the landmine recorded
    in CLAUDE.md - they share no state), but they do all end up writing
    text into these elements.
  */

  var COUNT = '[data-cart-count]';
  var EMPTY = 'is-cart-empty';
  var watched = [];

  function targetFor(el) {
    // The phone badge IS the count. In "Cart (N)" the brackets have to go
    // with the number, so the class lands on the wrapper that holds both.
    return (el.closest && el.closest('[data-cart-count-wrap]')) || el;
  }

  function sync(el) {
    var digits = (el.textContent || '').replace(/[^0-9]/g, '');
    var count = digits === '' ? 0 : parseInt(digits, 10);
    var target = targetFor(el);
    if (count > 0) target.classList.remove(EMPTY);
    else target.classList.add(EMPTY);
  }

  function wire() {
    var nodes = document.querySelectorAll(COUNT);
    Array.prototype.forEach.call(nodes, function (el) {
      sync(el);
      if (watched.indexOf(el) !== -1) return;
      watched.push(el);
      if (!window.MutationObserver) return;
      // characterData for a text node written in place, childList for
      // jQuery's .text() which replaces the node outright.
      new MutationObserver(function () { sync(el); }).observe(el, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();

  // The header re-renders in the theme editor, and the sticky header is
  // built from the same markup; wire() skips what it has already seen.
  document.addEventListener('shopify:section:load', wire);
  window.addEventListener('pageshow', wire);
})();
